import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import FooterContainer from 'src/components/footer/footer';

function AviatorBetToWinBoostFun(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            <InformationWrapper>
                <Container>
                    <p>Exchange your Asia Cup bets for Free Bets on Evolution Games. High stakes during the <br /> tournament unlock higher rewards!</p>
                </Container>

                <Container>
                    <MainTitle>How to participate</MainTitle>
                    <KeyDetailsSec>
                        <KeyDetailsSecWrap>
                            <KeyDetailsSecBox>
                                <img src={`${config.imageV3Host}/static/cashsite/${theme.image.AviatorBetToWinBoostIconOne}`} />
                                <p>Place qualifying bets during the Asia Cup.</p>
                            </KeyDetailsSecBox>

                            <KeyDetailsSecBox>
                                <img src={`${config.imageV3Host}/static/cashsite/${theme.image.AviatorBetToWinBoostIconTwo}`} />
                                <p>Cross staking tiers to unlock Free Bets.</p>
                            </KeyDetailsSecBox>

                            <KeyDetailsSecBox>
                                <img src={`${config.imageV3Host}/static/cashsite/${theme.image.AviatorBetToWinBoostIconThree}`} />
                                <p>Receive Free Bets credited after the tournament.</p>
                            </KeyDetailsSecBox>
                        </KeyDetailsSecWrap>
                    </KeyDetailsSec>
                </Container>

                <Container>
                    <MainTitle>Reward Tiers</MainTitle>
                    <ImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.AviatorBetToWinBoostTierImg}`}
                            alt="Reward Tiers"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </ImageWrapper>
                </Container>

                <TermsAndCondition>
                    <MainTitle>Terms & Conditions</MainTitle>
                    <ol>
                        <li>Place bets worth ₹1,00,000 or more during Asia Cup (Sep 9-25).</li>
                        <li>Only bets on Exchange markets are considered.</li>
                        <li>Free Bets credited by Sep 28, 2025.</li>
                        <li>Free Bets valid only on respective providers.</li>
                        <li>Standard brand T&Cs apply.</li>
                    </ol>
                </TermsAndCondition>
            </InformationWrapper>
            <FooterContainer />
        </>
    )
}

export default withTheme(withAppContext(AviatorBetToWinBoostFun));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 3rem;
    padding-top: 1.2rem;
    background: rgba(111, 111, 111, 0.5);
    margin: 0em;
    border-top-color: transparent;
    backdrop-filter: brightness(0.5);    
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    background-color: #EBEBEB;
    text-align: center;
`;

const Container = styled.div`
    width: 100%;
    max-width: 1120px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 2rem 0;
    gap: 1.7rem;
    border-radius: 9.945px;
    background: #FFF;
`;

const MainTitle = styled.h4`
    color: #06A6FF;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    text-transform: capitalize;
    text-align: center;
    margin: 0;
`;

const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    margin: 1rem auto;
    width: 100%;
    height: auto;
`;

const KeyDetailsSecWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 1.5rem;
`;

const KeyDetailsSecBox = styled.div`
    width: 25%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    padding: 1.5rem 2.5rem;
    border-radius: 6px;
    border: 1px solid #06A6FF;
    background: #06A6FF;

    img {
        width: 85px;
    }

    & p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        text-transform: capitalize;
        margin: 3px 0px;
    }
`;

const ImageWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 5px 1rem 2rem 1rem;
    position: relative;

    & img {
        width: 65%;
        height: auto;
    }
`;

const TermsAndCondition = styled.div`
    width: 100%;
    max-width: 1120px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 2.5rem;
    gap: 1.7rem;
    border-radius: 9.945px;
    background: #FFF;

    ol {
        padding: 0;
        margin-top: 5px;
        list-style: decimal;
        width: 35%;
        display: flex;
        flex-direction: column;
        gap: 10px;

        li {
            color: #444;
            text-align: left;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            text-transform: capitalize;
        }
    }
`;